module.exports = __webpack_public_path__ + "static/media/display_image.9947903c.png";